import { Role } from 'generated/graphql';

export const options = (array?: any[] | null) => {
  const collator = new Intl.Collator();

  const mappedOptions = array?.map(manager => {
    const { firstname, lastname, id } = manager;
    return {
      name: lastname + ' ' + firstname,
      id,
    };
  });

  return mappedOptions?.sort((a, b) => {
    return collator.compare(a.name, b.name);
  });
};

export const getInheritedResponsibles = (object: any, role: Role) => {
  const responsibles = new Map();

  const addResponsibles = (obj: any, isInherited = false) => {
    obj?.responsibleUsers?.forEach((user: any) => {
      if (user.role === role && !responsibles.has(user.id)) {
        responsibles.set(user.id, { ...user, isInherited });
      }
    });
  };

  addResponsibles(object);

  addResponsibles(object?.parent, true);

  addResponsibles(object?.parent?.parent, true);

  return Array.from(responsibles.values());
};
